const MENU_TYPES = {
    DETAIL: "detail",
    VISIBILITY: "visibility",
    DEVELOPER: "developer",
};

const Items = (that) => [
    {
        enabled: true,
        key: MENU_TYPES.DETAIL,
        label: that?.$t("Linkedin Channel Detail") || "Linkedin Channel Detail",
        icon: {
            type: "material-icons",
            name: "info",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.VISIBILITY,
        label: that?.$t("multi_whatsapp_api.visibility") || "Visibility",
        icon: {
            type: "material-icons",
            name: "visibility",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.DEVELOPER,
        label: "Developer",
        icon: {
            type: "material-icons",
            name: "code",
        },
    },
];

export default {
    MENU_TYPES,
    Items,
};
